export const brand = {
  danger: {
    '100': '#fce4e4',
    '200': '#f7c5c5',
    '300': '#f09898',
    '400': '#e47474',
    '500': '#c41c1c',
    '600': '#a51818',
    '700': '#7d1212',
    '800': '#430a0a',
    '900': '#240505',
    '050': '#fef6f6',
  },
  neutral: {
    '100': '#f9fafb',
    '200': '#dde7ee',
    '300': '#cdd7e1',
    '400': '#9fa6ad',
    '500': '#636b74',
    '600': '#555e68',
    '700': '#32383e',
    '800': '#171a1c',
    '900': '#0b0d0e',
    '050': '#fbfcfe',
    // Figma `#F8F9FA` (project shell page fill — Figma 1408:65825 / 590:58830).
    // Sits between '050' (#fbfcfe) and '100' (#f9fafb); kept as a distinct token
    // because Figma uses this exact value for app-page backgrounds.
    '075': '#f8f9fa',
    '150': '#e5e5e5',
  },
  ocean: {
    '100': '#e3effb',
    '200': '#c7dff7',
    '250': '#AED0F2',
    '300': '#97c3f0',
    '400': '#4393e4',
    '450': '#257FD9',
    '500': '#0b6bcb',
    '600': '#185ea5',
    '700': '#12467b',
    '800': '#0a2744',
    '900': '#051423',
    '050': '#edf5fd',
  },
  primary: {
    light: {
      '100': '#f5fbf4',
      '200': '#e8f7e7',
      '300': '#d9f1d7',
      '400': '#c7eac4',
      '500': '#b1dfad',
      '600': '#92d08e',
      '700': '#64bb61',
      '800': '#1f7a1f',
      '900': '#056b0a',
      '1000': '#1A5719',
      '1100': '#203d1e',
      '050': '#fbfefa',
    },
    dark: {
      '100': '#121b12',
      '200': '#172b16',
      '300': '#153c13',
      '400': '#194b18',
      '500': '#1e5b1d',
      '600': '#236c22',
      '700': '#257f24',
      '800': '#1f7a1f',
      '900': '#20691f',
      '1000': '#79d074',
      '1100': '#b1f7ad',
      '050': '#0b140b',
    },
  },
  warning: {
    '100': '#fdf0e1',
    '200': '#fce1c2',
    '300': '#f3c896',
    '400': '#ea9a3e',
    '500': '#9a5b13',
    '600': '#72430d',
    '700': '#492b08',
    '800': '#2e1b05',
    '900': '#1d1002',
    '050': '#fefaf6',
  },
  common: { white: '#ffffff', black: '#000000', green: '#127C16', purple: '#A749D3' },
  function: {
    light: {
      green: {
        '100': '#1fa21c',
        '90': '#35ab33',
        '80': '#4cb549',
        '70': '#62be60',
        '60': '#79c777',
      },
      lime: {
        '100': '#86bd09',
        '90': '#92c422',
        '80': '#9eca3a',
        '70': '#aad153',
        '60': '#b6d76c',
      },
      yellow: {
        '100': '#ebc606',
        '90': '#edcc1f',
        '80': '#efd138',
        '70': '#f1d751',
        '60': '#f3dd6a',
      },
      orange: {
        '100': '#ff8310',
        '90': '#ff8f28',
        '80': '#ff9b3f',
        '70': '#ffa857',
        '60': '#ffb46f',
      },
      red: { '100': '#ef5928', '90': '#f16a3d', '80': '#f27a53', '70': '#f48b68', '60': '#f59b7e' },
      neutral: {
        '100': '#000000',
        '90': '#1a1a1a',
        '80': '#333333',
        '70': '#4d4d4d',
        '60': '#666666',
        '50': '#808080',
        '40': '#999999',
        '30': '#b3b3b3',
        '20': '#cccccc',
        '10': '#f9fafb',
      },
      fuel: {
        '100': '#bb7bb5',
        '90': '#c288bc',
        '80': '#c995c3',
        '70': '#cfa2cb',
        '60': '#d6b0d2',
      },
      ocean: '#4b6399',
      'tennis-green': '#BDDB42',
    },
    dark: {
      green: {
        '100': '#22c11f',
        '90': '#1fae1c',
        '80': '#1b9b18',
        '70': '#188716',
        '60': '#157412',
      },
      lime: {
        '100': '#9eda18',
        '90': '#8ec416',
        '80': '#7eae13',
        '70': '#6f9911',
        '60': '#5f830e',
      },
      yellow: {
        '100': '#ffdb1d',
        '90': '#e5c51a',
        '80': '#ccaf17',
        '70': '#b29914',
        '60': '#998311',
      },
      orange: {
        '100': '#ff8f0c',
        '90': '#e5810b',
        '80': '#cc730a',
        '70': '#b26409',
        '60': '#995607',
      },
      red: {
        '100': '#ee4520',
        '90': '#d63e1d',
        '80': '#be3719',
        '70': '#a73016',
        '60': '#8f2913',
      },
      neutral: {
        '100': '#ffffff',
        '90': '#e5e5e5',
        '80': '#cccccc',
        '70': '#b3b3b3',
        '60': '#999999',
        '50': '#808080',
        '40': '#666666',
        '30': '#424242',
        '20': '#333333',
        '10': '#1a1a1a',
      },
      fuel: {
        '100': '#ba51eb',
        '90': '#a749d3',
        '80': '#9541bc',
        '70': '#8239a4',
        '60': '#3d1a4d',
      },
      ocean: '#3f57d4',
    },
  },
  base: {
    light: {
      forest: { '90': '#2a892d', '80': '#419645', '70': '#59a35c', '60': '#71b073' },
    },
    dark: {
      forest: {
        '100': '#1d9922',
        '90': '#1a8a1e',
        '80': '#177a1b',
        '70': '#146b18',
        '60': '#115c14',
      },
    },
  },
  sky: {
    dark: {
      '100': '#00cde5',
      '200': '#00b6cc',
      '300': '#00a0b2',
      '400': '#008999',
      '050': '#00e4ff',
    },
    light: {
      '100': '#5db6c2',
      '200': '#46abb9',
      '300': '#2ea1b1',
      '400': '#1797a8',
      '050': '#74c0cb',
    },
  },
  expert: {
    light: {
      '100': '#8239a4',
      '075': '#9541BC',
      '050': '#A749D3',
      '025': '#E8D4F5',
      '015': '#F7EEFF',
    },
    dark: { '100': '#3d1a4d', '050': '#8239a4' },
  },
  cta: {
    light: { '050': '#c06be8', '100': '#82289e', '200': '#530163', '300': '#3a0a44' },
    dark: { '050': '#c06be8', '100': '#82289e', '200': '#530163', '300': '#3a0a44' },
  },
  blur: { light: '#ededed', dark: '#393939' },
  linearGradient: {
    light: 'linear-gradient(270deg, #8239A4 0%, #A749D3 100%)',
    dark: 'linear-gradient(270deg, #3D1A4D 0%, #8239A4 100%)',
  },
  hyperlink: {
    cell: {
      light: '#eaf3fd',
      dark: '#162126',
    },
    text: {
      light: '#3874cb',
      dark: '#9cc8f5',
    },
    underline: {
      light: '#b0c8ea',
      dark: '#495b6e',
    },
  },
  filter: {
    light: '#ededed',
    dark: '#393939',
  },
  /**
   * Chart fallback palette — used when data series exceed the number of semantic tokens.
   * These are intentionally raw hex values as they are data-visualization colors,
   * not UI component colors. They must be visually distinct from each other.
   */
  chartPalette: [
    '#6B8E23',
    '#4682B4',
    '#D2691E',
    '#8FBC8F',
    '#DAA520',
    '#B0C4DE',
    '#20B2AA',
    '#778899',
    '#7B68EE',
    '#9ACD32',
    '#CD5C5C',
    '#FF8C00',
    '#BA55D3',
    '#9370DB',
    '#3CB371',
    '#40E0D0',
    '#FF6347',
    '#FFB6C1',
    '#FFD700',
    '#6A5ACD',
    '#ADFF2F',
    '#FF4500',
    '#D2B48C',
    '#8A2BE2',
    '#5F9EA0',
    '#D8BFD8',
    '#2E8B57',
    '#FF7F50',
    '#FF1493',
    '#48D1CC',
    '#C71585',
    '#7FFFD4',
    '#DC143C',
    '#FFA07A',
    '#8B0000',
    '#B22222',
    '#8B4513',
    '#DA70D6',
    '#BDB76B',
    '#556B2F',
    '#8FBC8F',
    '#483D8B',
    '#FF00FF',
    '#EE82EE',
    '#98FB98',
    '#66CDAA',
    '#9932CC',
    '#FA8072',
    '#D3D3D3',
    '#4682B4',
  ] as const,
  table: {
    light: '#F7EEFF',
    dark: '#665575',
    circle: '#B0B0B0',
  },
  /**
   * Estimated GHG header (Figma 590:58831) — blue window-border around the
   * sliding rating range on the 8-grade colored bar.
   */
  estimatedGhg: {
    windowBorder: '#247ED8',
  },
  /**
   * MarketLabels chip palette (Figma 1836:236645) — paired (bg, dot, accent) per
   * backend `color_hex`. Indexed by the backend's accent color so the mapper can
   * pick the softer (bg, dot) UI pair without hand-coding a switch.
   */
  chip: {
    green: { accent: '#6BCB77', bg: '#D9F1D7', dot: '#92D08E' }, // approved
    yellow: { accent: '#FFD93D', bg: '#FBF6DD', dot: '#F3DD6A' }, // pending
    red: { accent: '#FF6B6B', bg: '#FCE4E4', dot: '#E47474' }, // not eligible
    grey: { accent: '#D3D3D3', bg: '#F0F0F0', dot: '#C7C7C7' }, // not assessed
    text: { muted: '#7A7A7A' },
  },
  /**
   * Market-label status-icon glyph colors, keyed by the backend `icon_name`,
   * per theme. Exact values from Figma "Market indicator" → Left Content icon.
   * Light: Projects 244:19295 / Retired 1837:259290.
   * Dark:  Projects 1837:349074 / Retired 1837:349557 (check/x/dash differ from
   * light; dash is lightened so it stays visible on the dark surface).
   * The chip border stays neutral; only the leading status icon takes these.
   */
  marketIndicatorIcon: {
    light: {
      check: '#1FA21C', // CheckFilled — approved
      clock: '#9A5B13', // AccessTimeFilled — transition / time-bound
      question: '#9A5B13', // question — potential
      x: '#C41C1C', // CloseFilled — not eligible
      dash: '#555E68', // Dash — not evaluated
    } as Record<string, string>,
    dark: {
      check: '#22C11F',
      clock: '#9A5B13',
      question: '#9A5B13',
      x: '#A51818',
      dash: '#9FA6AD',
    } as Record<string, string>,
  },
  /**
   * Chart-specific data-viz tokens for GHG rating methodology charts.
   * Used in ECharts configs for REDD+ baselines, issuance/retirement graphs, etc.
   */
  chart: {
    blue: { dark: '#2A3A8E', mid: '#384DBD', light: '#4661EC', muted: '#37528E', info: '#4992ff' },
    red: { dark: '#8F2913', light: '#EE4520' },
    yellow: { dark: '#FFCB13', mid: '#FFCB14', light: '#ffff00', gold: '#FFB800' },
    green: '#22C11F',
    /** GHG methodology table colors (CMS conditional formatting) */
    heatmap: {
      trendGreen: '#6aa84f',
      trendRed: '#e06666',
      scoreGreen: '#93c47d',
      scoreYellow: '#ffd966',
      scoreRed: '#e06666',
      tableBg: '#f7f3f0',
      tableBorder: '#ded0c4',
      tableText: '#000000',
    },
    /** Track color for circular progress / semicircle gauges */
    trackLight: '#f0f4f8',
    trackDark: '#171a1c',
    /** Scatter/chart misc colors */
    scatterGreen: '#4CAF50',
    currentProject: '#9333EA',
    gridGray: '#A0A0A0',
    axisText: '#3A3B3C',
    mutedBar: '#BDBDBD',
    lightBorder: '#E0E0E0',
  },
};
